import {
  Container,
  FormattedDateTime,
  Loading,
  NotificationActions,
  Panel,
  Table,
  formatUtils
} from '@elotech/components';
import { UserService, withService } from 'itbi-common/service';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

export class AuthorizationHistory extends React.Component {
  static propTypes = {
    userService: PropTypes.object.isRequired,
    showNotification: PropTypes.func.isRequired
  };
  state = {
    loading: false,
    listUserAuthorized: []
  };

  componentDidMount() {
    this.getHistoryAuthorization();
  }

  getHistorySuccess = response => {
    this.setState({ listUserAuthorized: response.data, loading: false });
  };

  getHistoryError = () => {
    this.setState({ loading: false });
    this.props.showNotification({
      level: 'warning',
      message: 'Não foi possível pesquisar o histórico de usuários autorizados'
    });
  };

  getHistoryAuthorization = () => {
    this.setState({ loading: true });
    this.props.userService
      .getUsuarioAutorizadoById()
      .then(this.getHistorySuccess)
      .catch(this.getHistoryError);
  };

  render() {
    const { listUserAuthorized, loading } = this.state;
    return (
      <Container title="Histórico de Autorizações" icon="history">
        <Loading loading={loading} />
        <Panel isTable>
          <Table values={listUserAuthorized}>
            <Table.Column
              name="usuarioAutorizado.cpfCnpj"
              header="CPF"
              value={item =>
                formatUtils.formatCpfCnpj(item.usuarioAutorizado.cpfCnpj)
              }
            />
            <Table.Column
              name="usuarioAutorizado.nome"
              header="Nome"
              value={item => item.usuarioAutorizado.nome}
            />
            <Table.Column
              name="dataAutorizacao"
              header="Data de Autorização"
              value={item => (
                <>
                  {item.dataAutorizacao && (
                    <FormattedDateTime
                      value={item.dataAutorizacao}
                      timeZone={'UTC'}
                    />
                  )}
                </>
              )}
            />
            <Table.Column
              name="dataExclusao"
              header="Data de Exclusão"
              value={item => (
                <>
                  {item.dataExclusao && (
                    <FormattedDateTime
                      value={item.dataExclusao}
                      timeZone={'UTC'}
                    />
                  )}
                </>
              )}
            />
            <Table.Column
              name="usuarioIp"
              header="IP da Autorização"
              value={item => item.ipUsuarioAutorizacao}
            />
            <Table.Column
              name="usuarioIp"
              header="IP da Exclusão"
              value={item => item.ipUsuarioExclusao}
            />
          </Table>
        </Panel>
      </Container>
    );
  }
}

const ComponentWithService = withService({
  userService: UserService
})(AuthorizationHistory);

const connectComponent = connect(null, {
  showNotification: NotificationActions.showNotification
})(ComponentWithService);

export default connectComponent;
